import { ICreateClienteUseCase } from "../../../presentation/useCases/create/create_cliente_use_case";
import { Cliente } from "../../models/cliente";
import { IComercialRepository } from "../../repositories/comercial_repositories";

/**
 * CreateClienteUseCase
 */

export class CreateClienteUseCase implements ICreateClienteUseCase {
  constructor(private readonly repository: IComercialRepository) { }

  async execute(form: Cliente): Promise<number> {
    return this.repository.createCliente(form);

  }
}
